import config from '@config'

import {
    PERSONS_REPRESENTATIVES_TABLE_CHANGE,
    PERSONS_REPRESENTATIVES_TABLE_CHANGE_REQUEST,
    PERSONS_REPRESENTATIVES_TABLE_LOADING_TRUE,
    PERSONS_REPRESENTATIVES_TABLE_LOADING_FALSE,
    PERSONS_REPRESENTATIVES_TABLE_DATA_RECEIVED,
} from './constants'

export function personsRepresentativesTableChange(module, blockKey, id, level, queryParams) {
    return {
        type: PERSONS_REPRESENTATIVES_TABLE_CHANGE,
        data: {
            module,
            blockKey,
            id,
            level,
            queryParams,
        },
    }
}

export function personsRepresentativesTableChangeRequest(module, blockKey, id, level, lang, token, queryParams) {
    return {
        type: PERSONS_REPRESENTATIVES_TABLE_CHANGE_REQUEST(id),
        payload: {
            uri: config?.api?.[module]?.[blockKey]?.block?.[3]?.uri,
            qs: {
                ...queryParams,
                entId: id,
                lang,
                token,
                level,
            },
            uriParams: {
                entId: id,
                lang,
            },
            headers: {
                'X-Token': token,
            },
        },
    }
}

export function personsRepresentativesTableDataReceived(module, id, blockKey, customData) {
    return {
        type: PERSONS_REPRESENTATIVES_TABLE_DATA_RECEIVED,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function personsRepresentativesTableLoadingTrue(module, id, blockKey, customData) {
    return {
        type: PERSONS_REPRESENTATIVES_TABLE_LOADING_TRUE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function personsRepresentativesTableLoadingFalse(module, id, blockKey, customData) {
    return {
        type: PERSONS_REPRESENTATIVES_TABLE_LOADING_FALSE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}
